import React, { type ReactElement } from 'react'
import { TextField, Typography, type TextFieldProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import cx from 'classnames'

import styles from './LabeledTextfield.module.scss'

type LabeledTextfieldProps = TextFieldProps & {
  textFieldStyle?: React.CSSProperties
  textFieldClassName?: string
}

const LabeledTextfield: React.FC<LabeledTextfieldProps> = ({
  label,
  className,
  style,
  textFieldClassName,
  textFieldStyle,
  ...rest
}): ReactElement => {
  const { palette } = useTheme()
  return (
    <div style={style} className={cx(styles.container, className)}>
      <Typography variant="title3">{label}</Typography>
      <TextField
        sx={{
          '& .MuiOutlinedInput-root': {
            fontSize: '16px',
            height: '60px',
            '&.Mui-error': {
              '&:hover fieldset': {
                borderColor: palette?.blue100.main,
              },
              '&.Mui-focused fieldset': {
                borderColor: palette?.blue100.main,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: palette?.blue900.main,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: palette?.blue100.main,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: palette?.blue100.main,
              },
            },
          },
        }}
        {...rest}
        style={textFieldStyle}
        className={textFieldClassName}
      />
    </div>
  )
}

export default LabeledTextfield
